import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import FlickityWidget from '../widget/FlickityWidget';
import Chart from '../../util/chart';
import ApiService from '../../services/ApiService';

const OpenQuotesPie = () => {
  const { isLoading, data = [] } = useQuery('open-quotes', async () => {
    const { data } = await ApiService.get('crm/quotes/open');
    return data;
  });

  const getQuotesByStatus = () => {
    if (isLoading) {
      return null;
    }
    const dataProvider = [];

    data.forEach(data => {
      dataProvider.push({ label: data.QuoteState.name, value: data.cnt, color: data.QuoteState.color });
    });

    Chart.makePieChart('quote-status-pie', {
      titles: [
        {
          text: 'Open Quotes By Status',
        },
      ],
      labelsEnabled: false,
      colorField: 'color',
      dataProvider,
    });
  };

  const getQuotesByAssignee = () => {
    return ApiService.get('crm/quotes/assignee').then(response => {
      const dataProvider = [];

      response.data.forEach(data => {
        dataProvider.push({ label: data.firstName, value: data.cnt });
      });

      Chart.makePieChart('quote-assignee-pie', {
        titles: [
          {
            text: 'Open Quotes By Assignee',
          },
        ],
        dataProvider,
      });
    });
  };

  useEffect(() => {
    getQuotesByStatus();
  }, [data]);

  useEffect(() => {
    getQuotesByAssignee();
  }, []);

  return (
    <FlickityWidget>
      <div id="quote-status-pie" className="stretch" />
      <div id="quote-assignee-pie" className="stretch" />
    </FlickityWidget>
  );
};

export default OpenQuotesPie;
